export const getNews = (state) => state.news.news;
export const getNewsIsLoading = (state) => state.news.isLoading;
export const getNewsHasError = (state) => state.news.hasError;
